import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestPluginFeedbackPost = {
  path: "/feedback/:slug",
  method: RouteHttpVerb.POST
};